import { useQuery } from '@tanstack/react-query';
import { isDemoProperty } from '../utils/isDemoCheck';
import propertyResponseMock from '../mocks/11080502/propertyResponse.json';
import { fetchPropertyData } from '@/features/property/api/fetchPropertyData';
import { BaseProperty } from '@/features/property/types';

export const usePropertyOrDemoData = (propertyId: number) => {
  const isDemo = isDemoProperty(propertyId);

  return useQuery({
    queryKey: ['property', propertyId, isDemo],
    queryFn: async () => {
      if (isDemo) {
        // Return mock data for demo
        return propertyResponseMock as BaseProperty;
      } else {
        // Make real API call
        return fetchPropertyData(propertyId);
      }
    },
  });
};